
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';

// Performance tab content
export const PerformanceTab = () => (
  <div className="p-4 space-y-6">
    <h3 className="text-lg font-medium mb-3">System Performance</h3>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h4 className="font-medium">Overall Efficiency</h4>
              <p className="text-gray-500 text-sm">Average across all zones</p>
            </div>
            <Badge variant={88 > 85 ? "secondary" : "destructive"} className="text-md px-3 py-1">
              88%
            </Badge>
          </div>
          <Progress value={88} className="h-2 mb-2" />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>Low</span>
            <span>Optimal</span>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h4 className="font-medium">Cycling Rate</h4>
              <p className="text-gray-500 text-sm">Cycles per hour</p>
            </div>
            <Badge variant="outline" className="text-md px-3 py-1">
              3.2
            </Badge>
          </div>
          <Progress value={65} className="h-2 mb-2" />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>Too Few</span>
            <span>Too Many</span>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h4 className="font-medium">Temperature Variance</h4>
              <p className="text-gray-500 text-sm">From setpoint (average)</p>
            </div>
            <Badge variant="outline" className="text-md px-3 py-1">
              1.2°F
            </Badge>
          </div>
          <Progress value={70} className="h-2 mb-2" />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>Minimal</span>
            <span>Significant</span>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h4 className="font-medium">Runtime Efficiency</h4>
              <p className="text-gray-500 text-sm">% of time in optimal range</p>
            </div>
            <Badge variant="outline" className="text-md px-3 py-1">
              78%
            </Badge>
          </div>
          <Progress value={78} className="h-2 mb-2" />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>Poor</span>
            <span>Excellent</span>
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);
